import { create } from 'zustand'
import type { FileItem } from '@/entities/files/model'

interface UIState {
  // ActiveKeys
  activeKeys: string[]
  setActiveKeys: (keys: string[]) => void

  // Files
  files: FileItem[]
  setFiles: (files: FileItem[]) => void
  resetFiles: () => void
}

export const useUIStore = create<UIState>((set) => ({
  // ActiveKeys
  activeKeys: [],
  setActiveKeys: (activeKeys) => set({ activeKeys }),

  // Files
  files: [],
  setFiles: (files) => set({ files }),
  resetFiles: () => set({ files: [] }),
}))
